import { BaseModel } from '@core/base-model';

import { NoteMediaType } from './note-media-type';

import { UserReadQuery } from '../user/read-model';

export interface NoteListQuery {
  body: string;
  createdAt: string;
  id: string;
  title: string;
  type: NoteMediaType;
  updatedAt: string;
  user: UserReadQuery;
}

export class NoteListModel extends BaseModel<NoteListQuery> {
  private body: string;
  private createdAt: string;
  private id: string;
  private title: string;
  private type: NoteMediaType;
  private updatedAt: string;
  private user: UserReadQuery;

  constructor(data: NoteListQuery) {
    super();

    this.update(data);
  }

  get asJson(): NoteListQuery {
    return {
      title: this.title,
      body: this.body,
      createdAt: this.createdAt,
      type: this.type,
      id: this.id,
      updatedAt: this.updatedAt,
      user: this.user,
    };
  }
}
